import styled from 'styled-components';

import {
  OffersInCartHeader as DefaultOffersInCartHeader,
  OffersInCartRemoveButton as DefaultOffersInCartRemoveButton,
  OffersInCartWrapper as DefaultOffersInCartWrapper,
} from './offers-in-cart.styled.default';

export * from './offers-in-cart.styled.default';

export const OffersInCartWrapper = styled(DefaultOffersInCartWrapper)`
  background: ${Styles.color.grey.three};
`;

export const OffersInCartHeader = styled(DefaultOffersInCartHeader)`
  p {
    color: ${Styles.color.white};
  }
`;

export const OffersInCartRemoveButton = styled(DefaultOffersInCartRemoveButton)`
  color: ${Styles.color.white};
  background-color: ${Styles.color.grey.three};

  &:focus,
  &:hover {
    color: ${Styles.color.white};
    background: ${Styles.color.grey.three};
  }
`;
